import { chakra, Flex } from '@chakra-ui/react';

import {
    topicFilterInputWidth
} from '@containers/activity-router/data-grid-container/courses/course-filters/topic-filters/topic-filter/topic-filter.styled';
import {
    CellDimensions,
    CourseContainerWidth, CourseElementDimensions
    , GridHeaderHeight
} from '@containers/activity-router/data-grid-container/data-grid-container.styled';

export const container = chakra(Flex, {
    label: 'loading-route-container',
    baseStyle: {
        alignItems: 'center',
        flexDirection: 'column',
        w: CourseContainerWidth.w
    }
});

export const topicFilter = {
    borderRadius: '6px',
    minH: `calc(${GridHeaderHeight} + ${CellDimensions.h})`,
    w: topicFilterInputWidth
};

export const course = {
    borderTopLeftRadius: '12px',
    borderBottomLeftRadius: '12px',
    marginTop: '0',
    minH: `calc(${GridHeaderHeight} + ${CellDimensions.h})`,
    w: '100%'
};

export const checkboxContainer = chakra(Flex, {
    label: 'loading-route-checkboxContainer',
    baseStyle: {
        flexDirection: 'column',
        w: CourseElementDimensions.w,
        minH: `calc(${GridHeaderHeight} + ${CellDimensions.h})`
    }
});
